import React, { Component, useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { Button, Form, FormGroup, Input, Label } from 'reactstrap'
import { session } from '../../../config'
class CaseFieldForm1 extends Component {
	constructor(props) {
		super(props)
		let apiUrl = session.get('apiUrl') || sessionStorage.getItem('apiUrl') || localStorage.getItem('apiUrl')
		this.state = {
			getSection: {
				method: 'GET',
				url: `${apiUrl}/ticketing/CaseSection?$filter=status eq 'Published'`,
			},
			sectionList: [],
			fieldMeta: props && props.meta && props.meta.fields ? props.meta.fields : {},
			formValues: {
				fieldName: null,
				status: null,
				fieldProperties: null,
			},
			formMeta: null,
			toggleModal: false,
			error: null,
			editMode: false,
		}
		this.handleChange = this.handleChange.bind(this)
		this.handleChildChange = this.handleChildChange.bind(this)
		this.handlePropsChange = this.handlePropsChange.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
	}
	async componentWillMount() {
		const { getSection } = this.state
		let { t } = this.props
		let sectionList = await this.props.executeRefApi(getSection, t)
		if (sectionList) this.setState({ sectionList })
	}

	componentDidMount() {}

	componentWillReceiveProps(nextProps) {
		const { formValue } = nextProps
		if (formValue) {
			let formMeta = null
			if (formValue.fieldProperties && formValue.fieldProperties.type) {
				formMeta = this.props.typeModal(formValue.fieldProperties.type)
				if (formMeta) this.setState({ formMeta, toggleModal: true })
			} else {
				formMeta = {}
			}
			this.setState({ formValues: formValue })
			if (formValue.id) this.setState({ editMode: true })
			else this.setState({ editMode: false })
		}
	}
	handleChange(e) {
		const { formValues } = this.state
		if (e.target.name === 'fieldName') {
			e.target.value = this.props.toCamelCase(e.target.value)
			this.setState({
				formValues: {
					...formValues,
					[e.target.name]: e.target.value,
					fieldProperties: {
						...formValues.fieldProperties,
						name: `data_${e.target.value.trim()}`,
					},
				},
			})
		} else {
			this.setState({
				formValues: {
					...formValues,
					[e.target.name]: e.target.value.trim(),
					fieldProperties: {
						...formValues.fieldProperties,
					},
				},
			})
		}
	}
	handleChildChange(e) {
		const { formValues } = this.state
		let name = e.target.name
		let value = e.target.value.trim()
		let formMeta = null
		if (name && name === 'type' && value != '') formMeta = this.props.typeModal(value)
		else if (name && name === 'type' && value == '') formMeta = {}

		this.setState({
			formValues: {
				...formValues,
				fieldProperties: {
					...formValues.fieldProperties,
					[name]: value,
				},
			},
		})

		if (formMeta) this.setState({ formMeta, toggleModal: true })
	}
	handlePropsChange(properties) {
		const { formValues } = this.state
		this.setState({
			formValues: {
				...formValues,
				fieldProperties: {
					...formValues.fieldProperties,
					...properties,
				},
			},
		})
	}

	toggle() {
		this.setState({ toggleModal: !this.state.toggleModal })
	}
	onSubmit(e) {
		const { formValues } = this.state
		let { t } = this.props
		e.preventDefault()
		let items = this.props.validateItems(formValues, t)

		if (items && items.error) this.setState({ error: items.error })
		else if (items) {
			this.props.onSubmit(items, t)
		} else {
			this.props.onSubmit(formValues, t)
		}

		this.setState({ error: null })
	}

	render() {
		const { t } = this.props
		const { fieldMeta, sectionList, formValues, createModal, toggleModal, formMeta, error, editMode } = this.state
		const { fieldName, fieldType, status } = fieldMeta
		const sectionName = fieldMeta.fieldProperties_sectionName || 'sectionName'
		return (
			<div className="row">
				<div className="col-sm-6">
					<Form onSubmit={this.onSubmit}>
						<FormGroup className="row">
							<div className="col-sm-3">
								<Label for="exampleEmail">{fieldName && fieldName.label ? t(fieldName.label) : t('Field Name')}</Label>
							</div>
							<div className="col-sm-9">
								<Input
									type={fieldName && fieldName.type ? fieldName.type : 'select'}
									name={fieldName && fieldName.name ? fieldName.name : 'sectionName'}
									value={(formValues && formValues[fieldName.name]) || ''}
									placeholder={fieldName && fieldName.placeholder ? t(fieldName.placeholder) : ''}
									required={(fieldName && fieldName.required) || false}
									onChange={this.handleChange}
									disabled={fieldName && fieldName.readOnlyOnEdit && editMode}
								/>
							</div>
						</FormGroup>

						<FormGroup className="row">
							<div className="col-sm-3">
								<Label for="exampleEmail">{sectionName && sectionName.label ? t(sectionName.label) : t('Section')}</Label>
							</div>
							<div className="col-sm-9">
								<Input
									type={sectionName && sectionName.type ? sectionName.type : 'text'}
									name={sectionName && sectionName.name ? sectionName.name : 'sectionName'}
									placeholder={sectionName && sectionName.placeholder ? t(sectionName.placeholder) : ''}
									value={(formValues && formValues.fieldProperties && formValues.fieldProperties[sectionName.name]) || ''}
									required={(sectionName && sectionName.required) || false}
									onChange={this.handleChildChange}
									disabled={sectionName && sectionName.readOnlyOnEdit && editMode}>
									<option value="">{t('--Select---')}</option>
									{sectionList &&
										Array.isArray(sectionList) &&
										sectionList.map((item, idx) => {
											return (
												<option key={idx} value={item.sectionName || item.id}>
													{t(item.sectionName)}
												</option>
											)
										})}
								</Input>
							</div>
						</FormGroup>

						<FormGroup className="row">
							<div className="col-sm-3">
								<Label for="exampleEmail">{fieldType && fieldType.label ? t(fieldType.label) : t('Type')}</Label>
							</div>
							<div className="col-sm-9">
								<Input
									type={fieldType && fieldType.type ? fieldType.type : 'text'}
									name={fieldType && fieldType.name ? fieldType.name : 'fieldType'}
									placeholder={fieldType && fieldType.placeholder ? t(fieldType.placeholder) : ''}
									required={(fieldType && fieldType.required) || false}
									onChange={this.handleChildChange}
									value={(formValues && formValues.fieldProperties && formValues.fieldProperties[fieldType.name]) || ''}
									disabled={fieldType && fieldType.readOnlyOnEdit && editMode}>
									<option value="">{t('--Select---')}</option>
									{fieldType &&
										fieldType.options &&
										Array.isArray(fieldType.options) &&
										fieldType.options.map((item, idx) => {
											return (
												<option key={idx} value={item.value || item.id}>
													{t(item.label)}
												</option>
											)
										})}
								</Input>
							</div>
						</FormGroup>

						{toggleModal && formMeta && (
							<TypeModal
								modal={toggleModal}
								formMeta={formMeta}
								toggle={this.toggle}
								fieldProperties={formValues && formValues.fieldProperties ? formValues.fieldProperties : {}}
								onChange={this.handlePropsChange}
								t={this.props.t}
								error={error}
							/>
						)}

						{/* <FormGroup className="row">
      <div className="col-sm-3"><Label for="exampleEmail">{fieldProperties && fieldProperties.label ? fieldProperties.label : 'Field Properties'}</Label></div>
      <div className="col-sm-9">  
      <Input 
        type={fieldProperties && fieldProperties.type ? fieldProperties.type : 'text'} 
        name={fieldProperties && fieldProperties.name ? fieldProperties.name : 'fieldProperties'}
        placeholder={fieldProperties && fieldProperties.placeholder ? fieldProperties.placeholder : ''} 
        required={fieldProperties && fieldProperties.required || false}
        rows={fieldProperties && fieldProperties.rows ? fieldProperties.rows : 10}
        onChange={this.handleChildChange}
      />

      </div>
      </FormGroup> */}

						<FormGroup className="row">
							<div className="col-sm-3">
								<Label for="exampleEmail">{status && status.label ? t(status.label) : t('Status')}</Label>
							</div>
							<div className="col-sm-9">
								<Input
									type={status && status.type ? status.type : 'text'}
									name={status && status.name ? status.name : 'fieldType'}
									placeholder={status && status.placeholder ? t(status.placeholder) : ''}
									required={(status && status.required) || false}
									onChange={this.handleChange}
									value={(formValues && formValues[status.name]) || ''}>
									<option>{t('--Select---')}</option>
									{status &&
										status.options &&
										Array.isArray(status.options) &&
										status.options.map((item, idx) => {
											return (
												<option key={idx} value={item.value || item.id}>
													{t(item.label)}
												</option>
											)
										})}
								</Input>
							</div>
						</FormGroup>

						<div className="pull-right">
							<Button color="primary">{editMode ? t('Update') : t('Create')}</Button>
						</div>
					</Form>
				</div>
				<div className="col-sm-6">{/* <pre>{JSON.stringify(formValues,null,4)}</pre> */}</div>
			</div>
		)
	}
}
export const CaseFieldForm = withTranslation()(CaseFieldForm1)

// CaseFieldForm.propTypes = {

const TypeModal = props => {
	const { formMeta, fieldProperties, t } = props
	const [modal, setModal] = useState(props.modal)
	const [properties, setProperties] = useState(fieldProperties)
	const [error, setError] = useState(props.error)
	const toggleModal = () => {
		props.toggle()
	}
	useEffect(() => {
		props.onChange(properties)
	}, [properties])
	useEffect(() => {
		props.error && setError(props.error)
	}, [props.error])
	const onChange = (item, e) => {
		let name = e.target.name
		let value = e.target.value
		setProperties({ ...fieldProperties, [name]: value })
	}
	const handleSelectChange = (item, e) => {
		let name = e.target.name
		let value = e.target.value
		setProperties({ ...fieldProperties, [name]: value })
	}
	const validateProps = () => {
		let parseProps = properties.options
		if (properties && properties.options) {
			try {
				parseProps = typeof properties.options === 'string' ? JSON.parse(properties.options) : properties.options
				parseProps.isStatic = properties.isStatic || 0
				setProperties({ ...fieldProperties, ...parseProps })
				setError(null)
			} catch (err) {
				setError({ options: `${t('There was a syntax error. Please correct it and try again:')} ${err}` })
			}
		}
	}
	const jsonPrettify = json => {
		if (typeof json === 'object' && json !== null) {
			const pretty = JSON.stringify(json, undefined, 4)
			return pretty
		}

		try {
			const obj = JSON.parse(json)
			return jsonPrettify(obj)
		} catch (err) {
			return json
		}
	}
	return (
		<>
			{/* <pre>{JSON.stringify(properties,null,2)}</pre> */}
			{formMeta &&
				Array.isArray(formMeta) &&
				formMeta.length > 0 &&
				formMeta.map((item, idx) => {
					let formValue = properties && properties[item.name] === false ? String(false) : properties[item.name]
					return (
						<FormGroup className="row" key={idx}>
							<div className="col-sm-3">
								<Label for="exampleEmail">{t(item.label) || ''}</Label>
							</div>
							<div className="col-sm-9">
								{item && item.type && item.type != 'select' && (
									<Input
										type={item && item.type ? item.type : 'text'}
										name={item && item.name ? item.name : 'text'}
										value={
											item && item.name === 'options' && properties && properties[item.name]
												? jsonPrettify(properties[item.name])
												: properties && properties[item.name]
												? properties[item.name]
												: ''
										}
										placeholder={item && item.placeholder ? t(item.placeholder) : t('Enter')}
										required={(item && item.required) || false}
										rows={item && item.rows ? item.rows : ''}
										onChange={onChange.bind(this, item)}
									/>
								)}
								{item && item.name && item.name === 'options' && (
									<Button style={{ marginTop: 10 }} className="pull-right" color="info" onClick={validateProps.bind(this, 'options')}>
										{t('Validate')}
									</Button>
								)}
								{error && error[item.name] && <span className="text-danger">{error[item.name]}</span>}

								{item && item.type && item.type === 'select' && (
									<Input
										type={item && item.type ? item.type : 'text'}
										name={item && item.name ? item.name : 'text'}
										placeholder={t(item && item.placeholder ? item.placeholder : 'Enter')}
										required={(item && item.required) || false}
										rows={item && item.rows ? item.rows : ''}
										onChange={handleSelectChange.bind(this, item)}
										value={formValue ? formValue : ''}>
										<option value="">{t('--Select--')}</option>
										{item &&
											item.options &&
											Array.isArray(item.options) &&
											item.options.map((elem, id) => (
												<option key={id} value={elem.value}>
													{t(elem.label)}
												</option>
											))}
									</Input>
								)}
							</div>
						</FormGroup>
					)
				})}
		</>
	)
}
